module.exports = {"title":"Get Started","body":"<p>The goal is a quickstart guide for GNOME desktop, for customization, tips and hints, various recommendations, and some frequently asked questions. If you\nsee something wrong, or you want something to be added,\n<a href=\"https://github.com/alex285/myGNOME/issues/\">just open an issue!</a></p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./docs/index.md
 ** module id = 535
 ** module chunks = 0
 **/